import React from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { getCurrentSub } from '../redux-store/thunks/subscriptions.thunks';
import { commandPaletteToggled } from '../redux-store/thunks/global.thunks';

import { DatahubObjectsPaletteId } from './DatahubObjectsPalette.container';

import { AppHeader } from '../components/app-header/AppHeader.view';

import type { RootState } from '../types/state.types';

export const AppHeaderContainer: React.FC = () => {
  const dispatch = useDispatch();

  const currentSub = useSelector((state: RootState) => getCurrentSub(state));
  const isLoggedIn = useSelector((state: RootState) => state.user.loggedIn);
  const darkModeActive = useSelector((state: RootState) => state.theme.dark);
  const isLiveUpdatesSupported = useSelector(
    (state: RootState) => state.subscription.supportsLiveUpdates
  );
  const currentPage = useSelector((state: RootState) => state.currentPage);
  const isLiveUpdatesEnabled = useSelector((state: RootState) => state.globals.enableLiveUpdates);
  const failedToConnectToLiveUpdates = useSelector(
    (state: RootState) => state.subscription.failedToConnectToLiveUpdates
  );
  const connected = useSelector((state: RootState) => state.subscription.connected);
  const isSubscriptionPages = !!currentPage.params?.subId;

  const showDatahubObjectsPalette = () => dispatch(commandPaletteToggled(DatahubObjectsPaletteId));

  return (
    <AppHeader
      subscriptionName={currentSub?.name}
      subscriptionId={currentSub?.id}
      isLoggedIn={isLoggedIn}
      darkModeActive={darkModeActive}
      isLiveUpdatesSupported={isLiveUpdatesSupported ?? false}
      isLiveUpdatesEnabled={isLiveUpdatesEnabled ?? false}
      showDatahubObjectsPalette={showDatahubObjectsPalette}
      isSubscriptionPages={isSubscriptionPages}
      connected={connected}
      failedToConnectToLiveUpdates={failedToConnectToLiveUpdates}
    />
  );
};
